<template>
  <div>
    <bread-crumb></bread-crumb>
    <manFormList
      :select="select"
      :selectList="selectList"
      :isBtn="isBtn"
      @empty="empty"
      @getChangeValue="getChangeValue"
    ></manFormList>
    <div class="box-table">
      <el-table :data="tableList" style="width: 100%" ref="multipleTable">
        <el-table-column prop="sid" label="会话SID"> </el-table-column>
        <el-table-column label="PINS" prop="pins">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.pins">{{ item }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createTime">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div>
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                slot="reference"
                >查看</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <el-drawer
      :title="`正在查看${drawerInfo.sid}会话的内容`"
      :visible.sync="drawerStatus"
      direction="rtl"
      :before-close="clearDrawer"
      :title-style="{ fontSize: '24px', fontWeight: 'bold', color: '#409EFF' }"
      size="50%"
    >
      <template slot="title">
        <h1>
          正在查看<a href="javascript:void;">{{ drawerInfo.sid }}</a
          >会话的内容
        </h1>
      </template>
      <div class="infinite-list-wrapper" style="overflow: auto">
        <el-timeline
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
          style="padding-bottom: 40px"
        >
          <el-timeline-item
            v-for="(activity, index) in drawerList"
            :key="index"
            :timestamp="formatDate(activity.timestamp)"
          >
            <template v-if="activity.body.render === 'sys'">
              <template>
                <b><a>【系统消息】</a>{{ activity.from.pin }}：</b
                >{{ activity.body.chatinfo.customJsonData.operateMsg }}
              </template>
            </template>
            <template v-else="activity.body.render === 'user'">
              <template v-if="activity.body.type === 'text'">
                <b>{{ activity.from.pin }}：</b>{{ activity.body.content }}
              </template>
              <template v-else-if="activity.body.type === 'image'">
                <div class="imageItem">
                  <b>{{ activity.from.pin }}：</b>
                  <el-image
                    style="height: 100px"
                    :src="activity.body.url"
                    :preview-src-list="srcList"
                  >
                  </el-image>
                </div>
              </template>
            </template>
          </el-timeline-item>
        </el-timeline>
        <p class="endtool" v-if="loading"><i class="el-icon-loading"></i></p>
        <p class="endtool" v-if="noMore">没有更多了</p>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import utils from "../../../../utils";
import baseTable from "../../../../components/baseTable";
import manFormList from "../../components/manFormList";
import breadCrumb from "../../../../components/breadCrumb";
import pagination from "../../../../components/pagination";
import { mapState } from "vuex";
import {
  jdh_man_privateLetterSession_page,
  jdh_man_dongDongMsg_page,
} from "@/api/man";
export default {
  data() {
    return {
      drawerStatus: false,
      drawerInfo: {},
      drawerList: [],
      tabInfo: [],
      loading: false,
      noHasMore: false,
      isBtn: 1,
      // 判断环境
      isUrl: "https://hlc.m.jd.com/doctorArticle/?editable=false&id=",
      ruleForm: {
        desc: "",
      },
      srcList: [],
      // form 表单绑定参数
      selectList: {
        pins: [], // 申请时间
        sids: [], // 审核状态
        createTime: [],
      },
      tenantid: null,
      select: [
        {
          prop: "createTime",
          type: "picker",
          placeholder: "请选择开始时间",
        },
        {
          prop: "pins",
          type: "select",
          placeholder: "可输入多个PIN,回车分割",
          List: [],
          allowCreate: true,
          multiple: true,
          defaultFirstOption: true,
          filterable: true,
        },
        {
          prop: "sids",
          type: "select",
          placeholder: "可输入多个会话SID,回车分割",
          List: [],
          allowCreate: true,
          multiple: true,
          defaultFirstOption: true,
          filterable: true,
        },
      ],
      // table表格
      tableList: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      rules: {
        desc: [{ required: true, message: "请填写驳回理由", trigger: "blur" }],
      },
      tableListValue: {},
      seletedListIds: "",
      // 全局常量
      commentSourceMap: [],

      dialogMultiImport: false,
      fileName: null,
      uploadShow: false,
    };
  },
  components: {
    baseTable,
    manFormList,
    breadCrumb,
    pagination,
  },

  async created() {
    this.tenantid = Number(this.$commonJs.getTenantId());
    this.pageManCommentInfos();
  },
  computed: {
    ...mapState(["imgHost", "userInfo"]),
    noMore() {
      return this.noHasMore;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  watch: {
    drawerList(newlist, oldlist) {
      this.srcList = [
        ...newlist
          ?.filter((item, index) => {
            return item.body.type === "image";
          })
          ?.map((item) => {
            return item.body.url;
          }),
      ];

      console.log(this.srcList, "this.srcList");
    },
  },
  methods: {
    clearDrawer() {
      this.drawerInfo = {};
      this.drawerList = [];
      this.loading = false;
      this.noHasMore = false;
      this.drawerStatus = false;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    load() {
      setTimeout(() => {
        this.getDongDongHistory({
          ...this.drawerInfo,
          startMid: this.drawerList[this.drawerList.length - 1].mid,
        });
        this.loading = false;
      }, 200);
    },
    getDongDongHistory(params) {
      console.log(params, "paramsparams");
      if (!params.sid) return;
      jdh_man_dongDongMsg_page({
        tenantId: Number(this.$commonJs.getTenantId()),
        ...params,
        pin: params.pins?.[0],
        count: 20,
      }).then((ret) => {
        if (!ret.msgs.length || ret.msgs.length < 20) {
          this.noHasMore = true;
        }
        this.drawerList = [...this.drawerList, ...ret.msgs];
      });
    },
    // table-按钮
    handleClick(data) {
      this.drawerInfo = {
        ...data,
      };
      this.drawerStatus = true;
      this.getDongDongHistory(data);
    },
    // 查询
    getChangeValue() {
      this.paginationDataProduct.currentPage = 1;
      this.paginationDataProduct.pageSize = 10;
      this.pageManCommentInfos();
    },
    // 重置
    empty(list) {
      this.paginationDataProduct.currentPage = 1;
      this.paginationDataProduct.pageSize = 10;
      Object.keys(this.selectList).map((item) => {
        console.log(this.selectList[item]);
        if (item == "commentSources") {
          this.selectList[item] = [];
        } else {
          this.selectList[item] = "";
        }
      });
      this.pageManCommentInfos();
    },
    // 分页
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageManCommentInfos();
    },
    // 分页请求
    async pageManCommentInfos() {
      console.log(this.selectList, "this.selectList");
      let data = {
        tenantId: Number(this.$commonJs.getTenantId()),
        pins: this.selectList?.pins?.length ? this.selectList?.pins : "",
        sids: this.selectList?.sids?.length ? this.selectList?.sids : "",
        startCreateTime:
          this.selectList?.createTime?.[0]?.getTime() || undefined,
        endCreateTime: this.selectList?.createTime?.[1]?.getTime() || undefined,
        pageIndex: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      };
      jdh_man_privateLetterSession_page(data).then((res) => {
        // console.log(res.data);
        this.tableList.splice(0, this.tableList.length);
        console.log(res.records, "res.data?.records");
        res?.records.map((item) => {
          if (item.commentSources) {
            item.commentSources = this.commentSourceMap[item.commentSources];
          }
          this.tableList.push(item);
        });
        this.paginationDataProduct.total = res.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.imageItem {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}
.infinite-list-wrapper {
  overflow-y: scroll;
  height: calc(100vh - 80px);
}
.box {
  padding-top: 10px;
  padding-right: 20px;
}

.box-table {
  background-color: #fff;
}

.tools {
  padding-top: 15px;
  padding-left: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  :deep(.el-tabs .el-tabs__header) {
    margin-bottom: 0;
  }
  :deep(.el-tabs .el-tabs__content) {
    padding-bottom: 0;
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

.border {
  margin: 0 5px 0;
  display: inline-block;
  height: 8px;
  width: 1px;
  /* background-color: black; */
  border: 0.9px solid #266cee;
}

.box_text {
  width: 100%;
  text-align: center;
  padding-top: 20px;
  font-size: 16px;
}

.Url {
  color: #266cee;
  cursor: pointer;
}

:deep(.commits) {
  em {
    color: red;
  }
}

.toolsItem {
  margin: 0 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 80vh;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
.endtool {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
}
</style>
